<script setup lang="js">
import { ref, onMounted, computed } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useAutonodeStore } from '@/stores/autonode.store';
import { useProjectStore } from '@/stores/project.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';

const autonodeStore = useAutonodeStore();
const projectStore = useProjectStore();
const { custom_variables, output_entities, outputVariableList, selectedOutputIndex } = storeToRefs(autonodeStore);
const { project } = storeToRefs(projectStore);
const { closeModal } = useModal();
const projectId = useRouteParams('projectId');

const variable = ref(null);
const entity_id = ref(null);
const columns = ref({});
const searchQueries = ref({});

const availableOutputEntities = computed(() => {
  return outputVariableList.value
    .map((variable) => {
      const result = { ...variable };
      const match = variable.name.match(/^(?<entity>input_.+)\.(?<id>\d+)$/);

      if (match) {
        result.entity = match.groups.entity;
        result.id = match.groups.id;
      }

      return result;
    })
    .filter((v) => v.entity);
});

const selectedCustomVariable = computed(() => {
  return custom_variables.value.find((cv) => cv.name == variable.value) || {};
});

const selectedOutputEntity = computed(() => {
  return availableOutputEntities.value.find((e) => e.id == entity_id.value) || {};
});

function createOutput() {
  let output = {};
  output.entity_id = entity_id.value;
  output.variable = variable.value;
  output.columns = columns.value;
  output.entity = selectedOutputEntity.value.entity;

  if (selectedOutputIndex.value !== null && selectedOutputIndex.value !== undefined) {
    output_entities.value[selectedOutputIndex.value] = output;
  } else {
    output_entities.value.push(output);
  }

  selectedOutputIndex.value = null;
  
  closeModal();
}
onMounted(() => {
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
  if (output_entities.value[selectedOutputIndex.value]) {
    let output_entity = { ...output_entities.value[selectedOutputIndex.value] };
    variable.value = output_entity.variable;
    columns.value = output_entity.columns;
    entity_id.value = output_entity.entity_id;
  }
});
function filteredOptions(list, variable) {
  const query = searchQueries.value[variable]?.toLowerCase() || '';
  return list.filter(item =>
    item.title?.toLowerCase().includes(query)
  );
}
</script>

<template>
  <ModalTemplateSide @submit="createOutput">
    <template v-slot:title>Добавить выходные данные</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Переменная</label>
        <input
          type="text"
          v-model="searchQueries['custom_variables']"
          placeholder="Поиск..."
          class="form-control mb-2"
        />
        <select v-model="variable" class="form-select">
          <option v-for="variable in filteredOptions(custom_variables, 'custom_variables')" :key="variable.name" :value="variable.name">
            {{ variable.title }}
          </option>
        </select>
      </div>
      <div class="mt-3">
        <label class="form-label">Поле (в исполняемой системе)</label>
        <input
          type="text"
          v-model="searchQueries['availableOutputEntities']"
          placeholder="Поиск..."
          class="form-control mb-2"
        />
        <select v-model="entity_id" class="form-select">
          <template v-for="ent in filteredOptions(availableOutputEntities, 'availableOutputEntities')" :key="ent.id">
            <option v-if="ent.type === selectedCustomVariable.type" :value="ent.id">
              {{ ent.title }}
            </option>
          </template>
        </select>
      </div>

      <div
        class="mt-4"
        v-if="selectedOutputEntity && selectedOutputEntity.entity === 'input_table'"
      >
        <h5>
          Столбцы (выберите соответствующие значения из переменной массива для записи в столбцы
          таблицы)
        </h5>
        <div class="mt-3" v-for="col in selectedOutputEntity.table_columns" :key="col.name">
          <label class="form-label">{{ col.title }}</label>
          <input
            type="text"
            v-model="searchQueries[col.name]"
            placeholder="Поиск..."
            class="form-control mb-2"
          />
          <select v-model="columns[col.name]" class="form-select">
            <template v-for="arrCol in filteredOptions(selectedCustomVariable.table_columns, col.name)" :key="arrCol.name">
              <option :value="arrCol.name" v-if="arrCol.type === col.type">
                {{ arrCol.title }}
              </option>
            </template>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:submit>Добавить</template>
  </ModalTemplateSide>
</template>
